<template>
	<div class="slide slide_hero creator-store-panel d-flex flex-column">
		<top-navigation-v6 :page="routeName" />

		<div class="flex">
			<div id="big">
				<h1 class="anim">Meet Your All·in·One Creator Store</h1>

				<Svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="transform: scale(10)">
					<Path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6 2.625a1.375 1.375 0 100 2.75 1.375 1.375 0 000-2.75zM3.875 4a2.125 2.125 0 114.25 0 2.125 2.125 0 01-4.25 0z"
						fill="#131F60"
					/>
					<Path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6 7.375a2.626 2.626 0 00-2.481 1.766.296.296 0 00.067.313.563.563 0 00.414.171h4a.563.563 0 00.414-.171.296.296 0 00.067-.313A2.626 2.626 0 006 7.375zm-3.19 1.52a3.376 3.376 0 016.38 0c.14.404.025.79-.219 1.06-.237.264-.594.42-.971.42H4c-.377 0-.734-.156-.971-.42a1.045 1.045 0 01-.219-1.06z"
						fill="#131F60"
					/>
				</Svg>

				<h3 class="anim">
					Stan is the <i> easiest </i> way to make money online. <br />
					All of your courses, digital products, and bookings are now hosted within your link-in-bio.
				</h3>
				<button id="cta" class="anim" @click="$emit('register')">
					<h2>Continue</h2>
					<img src="@/assets/images/home/v6/arrow.svg" />
				</button>
			</div>
			<div id="hero">
				<img id="hero_phone_1" class="hero_phone" src="@/assets/images/home/v6/stan-hero-1.png" />
				<img id="hero_phone_2" class="hero_phone" src="@/assets/images/home/v6/stan-hero-2.png" />

				<img id="hero_bubble_1" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-8.png" />
				<img id="hero_bubble_2" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-6.png" />
				<img id="hero_bubble_3" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-7.png" />

				<img id="hero_card_1" class="hero_card" src="@/assets/images/home/v6/stan-hero-3.png" />
				<img id="hero_card_2" class="hero_card" src="@/assets/images/home/v6/stan-hero-4.png" />
				<img id="hero_card_3" class="hero_card" src="@/assets/images/home/v6/stan-hero-5.png" />
			</div>
		</div>
	</div>
</template>

<script>
	import { defineComponent, getCurrentInstance, ref, onUnmounted } from 'vue'
	import TopNavigationV6 from '@/components/header/TopNavigationV6'
	import { useRoute } from 'vue-router'

	let animationId

	export default defineComponent({
		name: 'LandingV6CreatorStore',
		components: {
			TopNavigationV6,
		},
		props: {
			id: {
				type: [String, Number],
			},
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const { name: routeName } = useRoute()
			onUnmounted(() => {
				if (animationId) {
					window.cancelAnimationFrame(animationId)
				}
			})
			return {
				routeName,
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
			}
		},
	})

	// Heewon's Animation Script
	let ratio = 0

	let loop = () => {
		if (window.scrollY < window.innerHeight * 2) {
			ratio = window.scrollY / window.innerHeight
			document.body.style.setProperty('--parallax-1', ratio * 1.4 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-2', ratio * 1.5 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-3', ratio * 1.6 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-4', ratio * 1 * -160 + 100 + 'px')
		}

		animationId = window.requestAnimationFrame(loop)
	}
	animationId = window.requestAnimationFrame(loop)
</script>

<style lang="scss" scoped>
	body {
		width: 100vw;
		overflow-x: hidden;
		image-rendering: -webkit-optimize-contrast;
		--parallax-1: 0;
		--parallax-2: 0;
		--parallax-3: 0;
		--parallax-4: 0;
	}

	.creator-store-nav {
		width: 100vw;
	}

	.landing-page-component {
	}

	#highlight {
		flex-direction: column;
		gap: 0;
		width: fit-content;
		position: relative;
		margin: 0 !important;
		padding: 0 !important;

		img {
			position: absolute;

			bottom: -10px;
			left: -10px;

			margin: 0;
			width: 360px;
		}
	}

	.flex {
		display: flex;
		justify-content: center !important;
		align-items: center;
		gap: 0;
		transform: translateY(-110px);
	}

	.slide {
		width: 100vw;
		padding: 0;
		background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1440" height="802" viewBox="0 0 1440 802" fill="none"><script xmlns=""/><path d="M0 0H1440V703.445L0 802V0Z" fill="%236355FF"/><script xmlns=""/></svg>');
		background-color: white;
		animation: fade 0.3s ease forwards;
	}

	@keyframes fade {
		from {
			opacity: 0;
			transform: translateY(30px);
		}
		to {
			opacity: 1;
			transform: translateY(0px);
		}
	}

	.flex {
		flex: 1;
		flex-wrap: nowrap;
		justify-content: center;
		margin-top: 30px;
		width: 90%;
	}

	.slide_hero {
		padding: 0;

		height: calc(100vh) !important;
		width: 110vw;

		background-size: cover;
		background-position: center bottom;
		color: white;

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		gap: 50px;

		#hero2 {
			background: green;
			position: relative;
			right: 0;
			top: 0;
			width: 750px;
			height: 750px;
			flex-shrink: 0;
			display: none;
		}

		#big {
			position: relative;
			right: 0;
			top: 0;
			flex: 1;
			max-width: max(700px, 30%);
			padding-left: 60px;

			h1 {
				font-size: 72px;
				line-height: 105%;
				font-weight: 800;
				letter-spacing: -1.5px;
				margin: 0;
				margin-bottom: 30px;
				color: white;
			}
			h3 {
				width: 70%;
				font-size: 18px;
				line-height: 130%;
				font-weight: 300;
				letter-spacing: 0.05px;
				margin: 0;
				margin-bottom: 40px;
				color: rgba(white, 0.6);
			}

			#cta {
				padding: 20px 35px;
				border-radius: 100px;
				background: #30ffb4;
				color: #131f60;
				outline: none;
				border: none;
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 15px;
				transition: 0.2s ease !important;

				h2 {
					font-size: 24px;
					font-weight: 800;
					letter-spacing: 0px;
					margin: 0;
				}
				img {
					height: 20px;
				}
				&:hover {
					gap: 30px;
				}
			}
		}

		@media screen and (min-width: 800px) {
			#hero {
				position: relative;
				right: 0;
				top: 0;
				width: 60%;
				max-width: 750px;
				aspect-ratio: 0.872;
				flex-shrink: 0;
				padding: 0;
				margin-right: -100px;
				z-index: 10;
				display: block;

				@supports not (aspect-ratio: 0.872) {
					height: 0;
					padding-top: max(54%, 600px);
				}
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					transform: translate(-50px, var(--parallax-1));
				}

				.hero_card {
				}

				// Phone
				#hero_phone_1 {
					transform: translate(0px, var(--parallax-4));
				}

				#hero_phone_2 {
					transform: translate(0px, var(--parallax-1));
				}

				// Card
				#hero_card_1 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_card_2 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_card_3 {
					transform: translate(0px, var(--parallax-1));
				}

				// Bubbles
				#hero_bubble_1 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_bubble_2 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_bubble_3 {
					transform: translate(0px, var(--parallax-1));
				}
			}
		}
		@media (min-width: 1200px) {
			#hero {
				width: 50%;
			}
		}
	}

	@media screen and (max-width: 800px) {
		.flex {
			display: flex;
			flex-direction: column;
			justify-content: center !important;
			align-items: center;
			gap: 0;
			transform: translateY(-110px);
		}

		.slide {
			background: #ebedff;

			width: 100vw;
			padding: 50px 0 50px 0;
		}

		#highlight {
			img {
				width: 180px;
				left: -5px;
				bottom: -12px;
			}
		}

		.slide_hero {
			width: 100vw;
			background: white;
			background-image: url('/public/images/home/v6/rect.svg');

			background-size: cover;
			background-position: center bottom;
			color: white;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			position: relative;
			height: calc(180vh);
			max-height: unset;
			overflow: hidden;
			#big {
				margin: auto;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;
				width: 95vw;
				height: fit-content;
				flex-shrink: 0;
				margin-top: 200px;
				transform: translateX(-20px);
				max-width: 3000px;

				h1 {
					font-size: 36px;
					line-height: 120%;
					font-weight: 700;
					letter-spacing: -0.2px;
					margin: 0;
					margin-bottom: 25px;
				}
				h3 {
					font-size: 15px;
					line-height: 140%;
					font-weight: 300;
					margin: 0;
					margin-bottom: 40px;
					color: rgba(white, 0.6);
				}

				#cta {
					width: 100%;
					padding: 20px 0;
					border-radius: 100px;
					background: #30ffb4;
					color: #131f60;

					display: flex;
					justify-content: center;
					align-items: center;
					gap: 15px;
					transition: 0.2s ease !important;

					h2 {
						font-size: 20px;
						font-weight: 800;
						letter-spacing: 0px;
						margin: 0;
					}
					img {
						height: 18px;
					}
					&:hover {
						gap: 30px;
					}
				}
			}

			#hero {
				width: calc(80vw * 1);
				height: calc(92vw * 1);
				flex-shrink: 0;
				padding: 0;
				transform: translate(60px, 20px);
				pointer-events: none;
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					pointer-events: none;
				}
			}
		}
	}
</style>
